import React from 'react';
import { getTheme, IStyle, ITheme, mergeStyles, Text } from '@fluentui/react';
import { Col, BwjGrid, Row } from '../../framework/components/bwj-layout';

function footerStyleFactory(theme: ITheme): IStyle[] {
  return [{
    padding: 15,
    backgroundColor: theme.palette.neutralLight,
  }];
};

function footerLinkListFactory(theme: ITheme): IStyle[] {
  return [{
    margin: 0,
    padding: 0,
    listStyleType: 'none',
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'flex-end',
    fontSize: 14,
    '& > li': {
      display: 'block',
      '& > a': {
        textDecoration: 'none',
        color: theme.palette.themePrimary,
        '& > hover': {
          textDecoration: 'underline',
        },
      },
    },
  }];
}

const linkDividerStyle: IStyle[] = [{
  padding: '0 5px',
}];

export const AppFooter: React.FunctionComponent = (props) => {

  const theme = getTheme();
  const footerClass = mergeStyles(footerStyleFactory(theme));
  const linkListClass = mergeStyles(footerLinkListFactory(theme));
  const dividerClass = mergeStyles(linkDividerStyle);

  return (
    <footer className={footerClass}>
      <BwjGrid>
        <Row>
          <Col medium={6} small={12}>
            <Text variant="medium">&copy; {(new Date()).getFullYear()} Sardonyx Digital Labs.  All rights reserved.</Text>
          </Col>
          <Col medium={6} small={12}>
            <ul className={linkListClass}>
              <li><a href="https://sardonyx.com/" target="blank">Sardonyx Digital Labs</a></li>
              <li className={dividerClass}>|</li>
              <li><a href="http://sardonyx.com/contact-us" target="blank">Contact Us</a></li>
              <li className={dividerClass}>|</li>
              <li><a href="/" target="blank">Terms of Use</a></li>
            </ul>
          </Col>
        </Row>
      </BwjGrid>
    </footer>
  );
};
